import { Controller, useFormContext } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';
import { TextInput } from '@gravity-ui/uikit';

interface FormTextInputProps {
	name: string;
	label: string;
	placeholder?: string;
	required?: boolean;
	className?: string;
}

export const FormTextInput = ({ name, label, placeholder, required = false, className }: FormTextInputProps) => {
	const { control } = useFormContext();

	return (
		<FormRow className={className} label={label} required={required}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, onBlur, ref, value }, fieldState: { error } }) => (
					<TextInput
						placeholder={placeholder || label}
						size="xl"
						hasClear
						error={error?.message}
						value={value || ''}
						onChange={onChange}
						onBlur={onBlur}
						ref={ref}
						errorPlacement="inside"
					/>
				)}
			/>
		</FormRow>
	);
};
